import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = 'https://rbuymart.rbhardwaj.com/server/api/orders';

const getHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
};

export const createOrder = createAsyncThunk(
    'orders/createOrder', 
    async (orderPayload, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE}/create.php`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(orderPayload) // user_id, amount, coupon_code, address
            });
            
            const data = await response.json();
            
            if (!response.ok || data.status === 'error') {
                return rejectWithValue(data.message || "Failed to create order.");
            }
            
            return data;
        } catch (error) {
            return rejectWithValue(error.message || "Network handshake failure.");
        }
    }
);

export const verifyPaymentSignature = createAsyncThunk(
    'orders/verifyPaymentSignature', 
    async (paymentPayload, { rejectWithValue }) => {
        try {
            const response = await fetch(`https://rbuymart.rbhardwaj.com/server/api/payments/verify.php`, {
                method: 'POST',
                headers: getHeaders(), // ✅ Header added for security
                body: JSON.stringify(paymentPayload)
            });
            
            const data = await response.json();
            
            if (!response.ok || data.status === 'error') {
                return rejectWithValue(data.message || "Payment verification failed.");
            }
            
            return data;
        } catch (error) {
            return rejectWithValue(error.message || "Network error during verification.");
        }
    }
);

const orderSlice = createSlice({
    name: 'orders', 
    initialState: { 
        activeOrder: null, 
        placementSuccess: false, 
        loading: false, 
        error: null 
    },
    reducers: { 
        resetOrderState: (state) => { 
            state.activeOrder = null; 
            state.placementSuccess = false; 
            state.error = null;
            state.loading = false;
        } 
    },
    extraReducers: (builder) => {
        builder
            // Create Order Lifecycle
            .addCase(createOrder.pending, (state) => { 
                state.loading = true; 
                state.error = null; 
                state.placementSuccess = false;
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.activeOrder = action.payload;
                state.error = null;
                if (action.payload.payment_method !== 'RAZORPAY') {
                    state.placementSuccess = true;
                }
            })
            .addCase(createOrder.rejected, (state, action) => { 
                state.loading = false; 
                state.error = action.payload; 
                state.placementSuccess = false;
            })

            // Verify Payment Lifecycle
            .addCase(verifyPaymentSignature.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyPaymentSignature.fulfilled, (state) => { 
                state.loading = false;
                state.placementSuccess = true; 
                state.error = null;
            })
            .addCase(verifyPaymentSignature.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.placementSuccess = false;
            });
    }
});

export const { resetOrderState } = orderSlice.actions;
export default orderSlice.reducer;